import { z } from "zod";

const updateRecordingSchema = z.object({
  name: z.string().min(1).optional(),
  summary: z.string().min(1).optional(),
  chapters: z
    .array(z.object({ title: z.string().min(1), start: z.number() }))
    .optional(),
});
type UpdateRecordingFormData = z.infer<typeof updateRecordingSchema>;

export { updateRecordingSchema };
export type { UpdateRecordingFormData };
